import { render } from "./ReportsPreview.vue?vue&type=template&id=3817619c"
import script from "./ReportsPreview.vue?vue&type=script&lang=js"
export * from "./ReportsPreview.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/arda/arda-front/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__